import CryptoJS from "crypto-js";

const SECRET_KEY = "reportdatahex123";

const hashKey = (key) =>
  CryptoJS.SHA256(key).toString(CryptoJS.enc.Hex);

export const secureSet = (key, value) => {
  try {
    const encryptedValue = CryptoJS.AES.encrypt(
      JSON.stringify(value),
      SECRET_KEY
    ).toString();

    localStorage.setItem(hashKey(key), encryptedValue);
  } catch (err) {
    console.error("Encryption Error:", err);
  }
};


export const secureGet = (key) => {
  try {
    const encrypted = localStorage.getItem(hashKey(key));
    if (!encrypted) return null;
    const bytes = CryptoJS.AES.decrypt(encrypted, SECRET_KEY);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);
    return decrypted ? JSON.parse(decrypted) : null;
  } catch (err) {
    console.error("Decryption Error:", err);
    return null;
  }
};

export const secureRemove = (key) => {
  localStorage.removeItem(hashKey(key));
};
